import styled, { css } from 'styled-components';
import { FlexColumnCenter } from '@ubeya/shared-web/components';

export const MiniEmpty = styled(FlexColumnCenter)`
  gap: 8px;
  padding: 24px 16px;
  text-align: center;

  > svg {
    width: 32px;
    height: 32px;
    opacity: 0.6;
  }
`;

export const MiniEmptyTitle = styled.div`
  font-size: 14px;
  line-height: 20px;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.black};
`;

export const MiniEmptyHint = styled.div`
  max-width: 320px;
  font-size: 12px;
  line-height: 18px;
  color: ${({ theme }) => theme.colors.grey4};
`;

export const MiniEmptyCta = styled.button`
  margin-top: 4px;
  background: none;
  border: none;
  padding: 0;
  font: inherit;
  font-size: 12px;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.primary};
  cursor: pointer;

  &:hover,
  &:focus {
    text-decoration: underline;
  }
`;

export const Badge = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  font-size: 11px;
  line-height: 16px;
  font-weight: 500;
  border-radius: 10px;

  ${({ $tone, theme }) => {
    if ($tone === 'paid')
      return css`
        background: ${theme.colors.greenExtraLight};
        color: ${theme.colors.greenPositive};
      `;
    if ($tone === 'unpaid')
      return css`
        background: ${theme.colors.grey1};
        color: ${theme.colors.grey4};
      `;
    if ($tone === 'manual')
      return css`
        background: ${theme.colors.yellowLight};
        color: ${theme.colors.orangeChanges};
      `;
    return css`
      background: ${theme.colors.grey1};
      color: ${theme.colors.grey4};
    `;
  }}
`;

export const NumericCell = styled.span`
  display: inline-block;
  width: 100%;
  text-align: right;
  font-variant-numeric: tabular-nums;

  ${({ $tone, theme }) => {
    if ($tone === 'positive')
      return css`
        color: ${theme.colors.greenPositive};
      `;
    if ($tone === 'negative')
      return css`
        color: ${theme.colors.redNegative};
      `;
    return css`
      color: ${theme.colors.black};
    `;
  }}
`;
